import BusinessRouteConfig from './BusinessRouteConfig';

export default BusinessRouteConfig;